import Kvittering from "../../components/Kvittering";
import {Link, useLocation} from "react-router-dom";
import {useEffect} from "react";
import {getDocumentTitle} from "../../utils/documentTitle";


export function OppsigelseKvittering() {
  const location = useLocation()
  const barnFulltNavn = location.state?.barnFulltNavn

  useEffect(()=> {
    document.title = getDocumentTitle("oppsigelse-kvittering")
  })

  return (
    <Kvittering>
      <h1 className={'pkt-txt-36 mt-size-104 mb-size-24'}>Oppsigelsen er sendt inn</h1>
      <p>
        Dette er en bekreftelse på at oppsigelse{barnFulltNavn ? ` for ${barnFulltNavn}` : 'n'} er sendt til behandling.
        Du får et brev i den digitale postkassen din (Altinn, eBoks, eller Digipost) når saken er ferdig behandlet.
      </p>
      <Link to={'/'} className={'pkt-btn mt-size-40'}>
        Gå til Din barnehageside
      </Link>
    </Kvittering>
  )
}